import React, { Fragment } from "react";
import CustomInput from "components/General/Form/CustomInput";
import * as CONSTANT from "constants/text";
import { FaRegTimesCircle } from "react-icons/fa";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import TextTheme from "../../General/Text/TextTheme";
import TwoButtonLayout from "../../General/Form/CustomButton/TwoButtonLayout";

class UpdatePassword extends React.Component {
  render() {
    return (
      <div className={this.props.showModal ? "modal show" : "modal"}>
        <div className="modal-body">
          {this.props.changeChallenge ? (
            <Fragment>
              <a href="javascript:void(0)" className="close" onClick={this.props.closeModal}>
                <FaRegTimesCircle size={20} style={{ fill: "#ff431b" }} />
              </a>
              <div className="mt-15 mb-15 modal-content">
                <TextTheme
                  message="Your project is already in progress with another challenge. Do you want to start with one more challenge? If you do so your previous challenge would be left incomplete. However you can continue on that anytime later."
                  className="text_medium text_black mb-15"
                />
                <div className="yes-no-btn">
                  <TwoButtonLayout
                    button1Text="No"
                    button2Text="Yes"
                    button1Click={() => this.props.closeModal()}
                    button2Click={() =>
                      this.props.startProject_new(this.props.challengeSlugName)
                    }
                  />
                </div>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <a
                href="javascript:void(0)"
                className="close"
                onClick={this.props.closeModal}
                style={{ display: this.props.pageSuccess ? "none" : "" }}
              >
                <FaRegTimesCircle size={20} style={{ fill: "#ff431b" }} />
              </a>
              <div
                className="modal-content"
                style={{ display: this.props.pageSuccess ? "none" : "" }}
              >
                <CustomInput
                  orientation="labeled"
                  name="oldPassword"
                  type="password"
                  placeholder={CONSTANT.OLD_PASSWORD}
                  label={CONSTANT.OLD_PASSWORD_COLON}
                  value={this.props.oldPassword}
                  handleChange={this.props.onDataChange}
                  required
                />
                <CustomInput
                  orientation="labeled"
                  name="newPassword"
                  type="password"
                  placeholder={CONSTANT.PASSWORD}
                  label={CONSTANT.PASSWORD_COLON}
                  value={this.props.newPassword}
                  handleChange={this.props.onDataChange}
                  required
                />
                <CustomInput
                  orientation="labeled"
                  name="confirmNewPassword"
                  type="password"
                  placeholder={CONSTANT.CONFIRM_PASSWORD}
                  label={CONSTANT.CONFIRM_PASSWORD_COLON}
                  value={this.props.confirmNewPassword}
                  handleChange={this.props.onDataChange}
                  required
                />
                <span className="page-error">{this.props.pageError}</span>
                <RoundedButton
                  title="&nbsp;&nbsp;&nbsp;Update&nbsp;&nbsp;&nbsp;"
                  buttonClassName="background_dark_orange"
                  textThemeClassName="text_medium text_white"
                  handleOnClick={this.props.onChangePasswordClicked}
                />
              </div>
              <div
                className="modal-content"
                style={{ display: !this.props.pageSuccess ? "none" : "" }}
              >
                <span className="page-success">
                  Password Updated Successfully. Please login again to continue.
                </span>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default UpdatePassword;
